<template><div><h1>VUX V2.1.0Rc.49 发布日志</h1>
<h2><a href="/zh-CN/components/form-preview.html">FormPreview</a></h2>
<ul><li>[fix] 修复出现滚动条 #920 @asingingfish</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] 支持`value-text-align` #921 @linhaobin</li>
<li>[fix] 修复`label`样式不受控于`group`属性的bug</li>
</ul>
<h2><a href="/zh-CN/components/x-input.html">XInput</a></h2>
<ul><li>[feature] 支持`slot=restricted-label` #918 @zqyadam</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.49 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.49-200.vue?c8720c3e